import type { QuizDetailsForTeacherData } from '@repo/api/quiz/quizService';

import { differenceInSeconds } from 'date-fns';
import { useMemo } from 'react';

export function useManageQuizStats(data?: QuizDetailsForTeacherData) {
  return useMemo(() => {
    if (!data) {
      return {
        score: {
          avg: NaN,
          avgFormatted: '-',
          cnt: 0,
          sum: 0,
        },
        attempt: {
          allowed: 0,
          attempt: 0,
          time: {
            sum: 0,
          },
        },
      };
    }
    const scoreStats = data.quizresps.reduce(
      (dObj, att) => {
        if (att.score != null) {
          dObj.cnt += 1;
          dObj.sum += att.score;
        } else {
          dObj.notMarked += 1;
        }

        return dObj;
      },
      { sum: 0, cnt: 0, notMarked: 0 }
    );

    const scoreAvg: number = scoreStats.cnt > 0 ? scoreStats.sum / scoreStats.cnt : NaN;

    const formattedScoreAvg: string = typeof scoreAvg === 'number' && !Number.isNaN(scoreAvg) ? String(scoreAvg.toFixed(2)) : '-';

    //attempt stats
    const allowedGroupUsersIds = new Set(data.groups.flatMap((group) => group.users.map((u) => u.id)));
    const allowedUserIds = new Set(data.users.map((u) => u.id));
    const allowedUsers = new Set<number>([...allowedUserIds, ...allowedGroupUsersIds]);
    const attemptUsers = new Set(data.quizresps.map((att) => att.userId));

    const timeStats = data.quizresps.reduce(
      (dObj, att) => {
        //only completed in this dashboard
        dObj.sum += differenceInSeconds(att.completedAt as string, att.createdAt);

        return dObj;
      },
      { sum: 0 }
    );

    return {
      score: {
        ...scoreStats,
        avg: scoreAvg,
        avgFormatted: formattedScoreAvg,
      },
      attempt: {
        allowed: allowedUsers.size,
        attempt: attemptUsers.size,
        time: timeStats,
      },
    };
  }, [data]);
}
